import { MutableRefObject, RefObject, useEffect } from "react";

const useOnClickOutside = (
  elementRef:
    | RefObject<HTMLElement>
    | MutableRefObject<HTMLElement>
    | (RefObject<HTMLElement> | MutableRefObject<HTMLElement>)[],
  onClick?: () => void,
  enabled?: boolean
): void => {
  useEffect(() => {
    if (
      !elementRef ||
      (!Array.isArray(elementRef) && !("current" in elementRef))
    ) {
      return;
    }

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.closest("[data-dropdown-panel]")) {
        return;
      }

      if (!Array.isArray(elementRef) && elementRef.current) {
        if (elementRef.current.contains(target)) {
          return;
        } else if (elementRef.current !== undefined) {
          onClick?.();
          return;
        }
      }
      if (elementRef && Array.isArray(elementRef)) {
        const elements = elementRef
          .filter((el) => el.current)
          .map((el) => el.current);

        if (elements.find((el) => el?.contains(target))) {
          return;
        } else {
          onClick?.();
          return;
        }
      }
    };
    if (enabled === undefined || enabled === true) {
      document.addEventListener("mousedown", handleClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [enabled, elementRef, onClick]);
};

export { useOnClickOutside };
